import React from "react";
import { withStyles } from "@material-ui/core/styles";
const styles = (theme) => ({
  dialogTitle: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 500,
  },
});

const DialogTitleHeader = ({ classes, label }) => (
  <span className={classes.dialogTitle}>{label}</span>
);

export default withStyles(styles)(DialogTitleHeader);
